import constants from './constants';
import configMixin from '@/mixins/configMixin';
import index from './index';
import SendboxItem2 from '@/components/sendbox/SendboxItem2';
const { ROUTES } = constants;

const elearningMixin = {
  mixins: [configMixin],
  methods: {
    elmx_getModuleUserState(module) {
      return this.$store.state.elearning.userStateByModuleId[module.id];
    },
    elmx_backToHome() {
      this.$router.push({ name: constants.ROUTES.HOME });
    },
    elmx_goTo(module, slideIndex) {
      console.debug('goTo slideIndex', slideIndex);

      if (module.is_practice == 1) {
        this.$router.push(`/${index.path}/training/${module.instance}/${module.id}/${slideIndex ? slideIndex : 0}`);
      } else {
        this.$router.push(`/${index.path}/exam/${module.instance}/${module.id}/${slideIndex ? slideIndex : 0}`);
      }
    },
    elmx_next(module, slideIndex) {
      console.debug('goTo slideIndex', slideIndex);

      if (module.is_practice == 1) {
        this.$router.push(`/${index.path}/training/${module.instance}/${module.id}/${slideIndex ? slideIndex : 0}`);
      } else {
        this.$router.push(`/${index.path}/exam/${module.instance}/${module.id}/${slideIndex ? slideIndex : 0}`);
      }
    },
    elmx_goToResult(module) {
      let type = module.is_practice == 1 ? 'training' : 'exam';
      this.$router.push(`/${index.path}/${type}/${module.instance}/${module.id}/result`);
    },
    elmx_onResume(module, slideIndex) {
      console.debug('onResume with slide', slideIndex);
      this.elmx_goTo(module, slideIndex);
    },
    elmx_isTraining(module) {
      return module.is_practice === 1;
    },
    elmx_isExam(module) {
      return module.is_practice === 0;
    },

    /**
     *
     * @param {Object} module - eLearning module metadata
     * @param {Object} payload - arbitrary payload to send with
     * @param {Object} userState - the userState to send
     * @param {Object} text - the text to display in sendbox and snackbar
     * @param {string} action - the action name, e.g. setElearningState
     * @param {boolean} showAsUserInfo - display in snackbar or the like
     * @param {boolean} showInSendbox - display sendbox
     * @param {boolean} writeAuditLog - write into the audit log table
     */
    elmx_createAndSendSendboxItem({ module, payload, userState, text, action, showAsUserInfo = false, showInSendbox = false, writeAuditLog = false }) {
      let moduleType = index.moduleType;

      let moduleConfig = this.getModuleConfig(moduleType, Number(this.$route.params.instance));

      let moduleTitle = moduleConfig ? this.$t('module') + ' ' + this.$t(moduleConfig.title) : '';
      let displayText = `<b>${moduleTitle}</b> - ${text}`;

      let userNotification = {
        show: showAsUserInfo,
        showInSendbox,
        title: this.$t('el.trainingTitle', { moduleName: module.name }),
        text: displayText,
      };

      let subject = module;

      let sendboxItem = new SendboxItem2({
        moduleType,
        moduleId: index.moduleId,
        writeAuditLog,
        userNotification,
        subject,
        payload,
        userState,
        action,
      });

      this.$store.dispatch('sendbox/addAndSendSendboxItems', {
        moduleId: index.moduleId,
        sendboxItems: [sendboxItem],
        notification: userNotification,
      });
    },
  },
  computed: {
    elmx_isTrainingsRoute() {
      return this.$route.name === ROUTES.TRAINING;
    },
    elmx_moduleFromRoute() {
      console.debug('elmx_moduleFromRoute');
      if (this.$route.params.moduleId) {
        let module = this.$store.state.elearning.modulesById[this.$route.params.moduleId];
        console.debug('found module', JSON.stringify(module, null, 2));
        return module;
      }
      return null;
    },
  },
};

export default elearningMixin;
